export const REPORT_FORM_TIP = {
  ORDER_PRINT: 1,
  ORDER_PACK_PRINT: 2,
  ORDER_ACTION: 3,
  PART: 4,
  TASK: 5,
  INVOICE: 6,
  CUTTING_REMAINDERS: 7,
  ROUTE: 8,
  REQUEST: 9,
  CRM_TASK: 10,
  FINISHED_GOODS: 11,
  ORDERS: 101
};

const REPORT_FORM_TIP_ITEMS = [
  { value: REPORT_FORM_TIP.ORDER_PRINT, label: "Заказ (печать)", obsolete: true },
  { value: REPORT_FORM_TIP.ORDER_PACK_PRINT, label: "Пакет заказов (печать)", obsolete: true },
  { value: REPORT_FORM_TIP.ORDER_ACTION, label: "Заказ (действие)", obsolete: true },
  { value: REPORT_FORM_TIP.PART, label: "Партия", obsolete: true },
  { value: REPORT_FORM_TIP.TASK, label: "Задание", obsolete: true },
  { value: REPORT_FORM_TIP.INVOICE, label: "Накладные", obsolete: true },
  { value: REPORT_FORM_TIP.CUTTING_REMAINDERS, label: "Остатки раскроя", obsolete: true },
  { value: REPORT_FORM_TIP.ROUTE, label: "Маршрут", obsolete: true },
  { value: REPORT_FORM_TIP.REQUEST, label: "Заявки", obsolete: true },
  { value: REPORT_FORM_TIP.CRM_TASK, label: "Задачи CRM", obsolete: true },
  { value: REPORT_FORM_TIP.FINISHED_GOODS, label: "СГП", obsolete: true },
  { value: REPORT_FORM_TIP.ORDERS, label: "Заказы" }
];

const formatReportFormTipLabel = (item) => (item.obsolete ? `${item.label} устар.` : item.label);

export const REPORT_FORM_TIP_OPTIONS = REPORT_FORM_TIP_ITEMS.map((item) => ({
  value: item.value,
  label: formatReportFormTipLabel(item)
}));

export function getReportFormTipName(value) {
  if (value === null || value === undefined || value === "") return "";

  const item = REPORT_FORM_TIP_ITEMS.find((option) => option.value === Number(value));
  return item ? formatReportFormTipLabel(item) : `Тип ${value}`;
}
